import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isSignIn$: Observable<boolean>;

  private isSignInSubject: Subject<boolean>;

  constructor(private http: HttpClient, private _cookie: CookieService) {
    this.isSignInSubject = new Subject<boolean>();
    this.isSignIn$ = this.isSignInSubject.asObservable();
  }

  signIn(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/api/login`, data);
  }

  signInWithToken(loginToken: string) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/auto-login/${loginToken}`
    );
  }

  resetPassword(data:any){
    return this.http.post<any>(`${environment.apiUrl}/api/lost-password`, data);
  }

  changePasword(data:any){
    return this.http.put<any>(`${environment.apiUrl}/api/changepassword`, data);
  }

  checkTokenPassword(data:any){
    return this.http.post<any>(`${environment.apiUrl}/api/token-login/`, data);
  }

  logout(isNotClearStorage?: boolean): Observable<any> {
    //UTILS.loader.show();
    // for (let i = 0; i < cookies.length; i++) {
    //     this._cookie.remove(cookies[i]);
    // }
    let cookies = [
      'user',
      'x-wsse',
      'user_rgpdvalide',
      'user_token',
      'x-sessid',
      'isConfirm',
      'keysitter_validator',
      'p__s',
      'eval-date',
      'Expires',
    ];
    for (let i = 0; i < cookies.length; i++) {
      this._cookie.set(cookies[i], '', { path: '/', sameSite: 'Lax' });
      this._cookie.delete(cookies[i], '/', '127.0.0.1');
      this._cookie.delete(cookies[i], '/', '.tdm.immo');
    }

    if (!isNotClearStorage) {
      localStorage.clear();
    }

    return of(true);
  }
}
